var _circle, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNoteEdit(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 68,
    height: 68,
    viewBox: "0 0 68 68",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 33.5385,
    cy: 33.6519,
    r: 33.4805,
    fill: "#E8FCF8"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_190_3675)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M33.5 48.7153C43.4972 48.7153 51.6015 40.6109 51.6015 30.6137C51.6015 20.6165 43.4972 12.5122 33.5 12.5122C23.5028 12.5122 15.3984 20.6165 15.3984 30.6137C15.3984 40.6109 23.5028 48.7153 33.5 48.7153Z",
    fill: "#FBBD5E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.9677 21.8477H50.9754V47.8615H19.0985C17.3338 47.8615 15.9108 46.4384 15.9108 44.7307V21.8477H15.9677Z",
    fill: "#E0E4E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.0322 48.4306H19.1553C17.1061 48.4306 15.4553 46.7799 15.4553 44.7306V21.8476C15.4553 21.5629 15.683 21.2783 16.0246 21.2783H51.0322C51.3169 21.2783 51.6015 21.506 51.6015 21.8476V47.8614C51.6015 48.2029 51.3169 48.4306 51.0322 48.4306ZM16.5369 22.4168V44.7876C16.5369 46.2106 17.6753 47.3491 19.0984 47.3491H50.4061V22.4168H16.5369Z",
    fill: "#183651"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.7554 24.0676H18.2446V44.7307C18.2446 45.1861 18.6431 45.5845 19.0985 45.5845H43.3477L48.6985 40.803V24.0676H48.7554Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.4045 45.6414L48.7553 40.803H43.4045V45.6414Z",
    fill: "#CECFD0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.9846 18.4324C17.3338 18.4324 15.9677 19.7985 15.9677 21.4493V44.4462C15.9677 42.7954 17.3338 41.4293 18.9846 41.4293C20.6353 41.4293 22.0015 42.7954 22.0015 44.4462V21.3924C21.9446 19.7416 20.6353 18.4324 18.9846 18.4324Z",
    fill: "#4FBF9F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.9446 45.0153C21.66 45.0153 21.3754 44.7877 21.3754 44.4461C21.3754 43.08 20.2938 41.9984 18.9277 41.9984C17.5615 41.9984 16.5369 43.1369 16.5369 44.4461C16.5369 44.7307 16.3092 45.0153 15.9677 45.0153C15.6261 45.0153 15.3984 44.7877 15.3984 44.4461V21.3923C15.3984 19.4569 16.9923 17.863 18.9277 17.863C20.8631 17.863 22.4569 19.4569 22.4569 21.3923V44.4461C22.5138 44.7877 22.2861 45.0153 21.9446 45.0153ZM18.9846 40.9169C19.8954 40.9169 20.7492 41.2584 21.4323 41.8846V21.3923C21.4323 20.0261 20.3507 18.9446 18.9846 18.9446C17.6184 18.9446 16.5369 20.0261 16.5369 21.3923V41.8277C17.1631 41.2584 18.0169 40.9169 18.9846 40.9169Z",
    fill: "#183651"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.9615 26.5154H32.1339V27.6538H24.9615V26.5154Z",
    fill: "#183651"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.9615 30.0447H32.1339V31.1831H24.9615V30.0447Z",
    fill: "#183651"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.9615 33.5737H32.1339V34.7122H24.9615V33.5737Z",
    fill: "#183651"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.9615 37.103H32.1339V38.2415H24.9615V37.103Z",
    fill: "#183651"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.1846 17.8062L36.9154 31.9231C35.8908 35.2246 36.0046 38.8108 37.2569 42.0554C40.1031 40.0062 42.1523 37.1031 43.1769 33.8015L47.4461 19.7415L41.1846 17.8062Z",
    fill: "#2EA0DA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.0861 42.6246C36.9153 42.5677 36.8015 42.4539 36.7446 42.2831C35.4923 38.9247 35.3784 35.1677 36.403 31.7523L40.6723 17.6354C40.7292 17.4646 40.843 17.3508 40.9569 17.2939C41.0707 17.237 41.2415 17.18 41.4123 17.237L47.6738 19.1154C47.9584 19.2293 48.1292 19.5139 48.0723 19.7985L43.803 33.9154C42.7784 37.3308 40.5584 40.4046 37.6553 42.4539C37.4277 42.6246 37.2569 42.6816 37.0861 42.6246ZM41.583 18.5462L37.4846 32.0939C36.5738 35.0539 36.6307 38.2416 37.5415 41.1446C39.9323 39.2093 41.7538 36.5908 42.6646 33.6308L46.763 20.0831L41.583 18.5462Z",
    fill: "#183651"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.3385 38.4693C38.0538 36.4769 38.2246 34.4277 38.7938 32.5493L42.4938 20.3108L44.9415 21.0508L41.2415 33.2893C40.6723 35.1677 39.6477 36.9323 38.3385 38.4693Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.9584 14.1631L43.86 12.9108C43.2907 12.74 42.6076 13.0816 42.4369 13.6508L41.1846 17.8062L47.4461 19.6847L48.6984 15.5293C48.8692 14.96 48.5276 14.3339 47.9584 14.1631Z",
    fill: "#F06151"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.4462 20.3107C47.3892 20.3107 47.3323 20.3107 47.2754 20.3107L41.0139 18.4323C40.7292 18.3184 40.5585 18.0338 40.6154 17.7492L41.8677 13.5938C42.0954 12.8538 42.7216 12.3984 43.4616 12.3984C43.6323 12.3984 43.8031 12.3984 43.9739 12.4554L48.0723 13.7077C48.5277 13.8215 48.8692 14.1061 49.0969 14.5046C49.3246 14.9031 49.3816 15.3584 49.2108 15.8138L47.9585 19.9692C47.9016 20.14 47.7877 20.2538 47.6739 20.3107C47.6169 20.2538 47.5031 20.3107 47.4462 20.3107ZM41.9246 17.4646L47.1046 19.0584L48.1862 15.4154C48.2431 15.2446 48.2431 15.1307 48.1292 14.96C48.0723 14.8461 47.9585 14.7323 47.7877 14.6754L43.6892 13.4231C43.4046 13.3092 43.0631 13.5369 43.0062 13.8215L41.9246 17.4646Z",
    fill: "#183651"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.9615 40.6323H26.1V41.7708H24.9615V40.6323Z",
    fill: "#183651"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.9785 40.6323H29.117V41.7708H27.9785V40.6323Z",
    fill: "#183651"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.9954 40.6323H32.1338V41.7708H30.9954V40.6323Z",
    fill: "#183651"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_190_3675"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 37,
    height: 37,
    fill: "white",
    transform: "translate(15 12)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoteEdit);
export default __webpack_public_path__ + "static/media/noteEdit.50ee3fbe8d9a7432ab35cfc6f5d67c9f.svg";
export { ForwardRef as ReactComponent };